/** Shared token object for text-input chrome (background / border / text). */
export const inputStyle = {
  backgroundColor: 'var(--bg)',
  border: '1px solid var(--border)',
  color: 'var(--text)',
}
